var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72 1.4C3.668.8 5.466.5 7.116.5c1.652 0 3.416.301 5.29.9.574.18 1.189.651 1.2 1.302.095 5.105-.176 7.576-.962 8.841-1.027 1.655-3.834 3.668-5.243 3.904a.782.782 0 01-.285.053c-.04 0-.04 0-.03-.002l-.079.002c-.097 0-.193-.018-.194-.028-1.5-.26-4.306-2.274-5.334-3.929C.695 10.278.424 7.807.518 2.702c.012-.65.626-1.122 1.201-1.302z",
    fill: "#D82121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.536L7.67 8.364l2.828 2.828-.707.707-2.828-2.828L4.136 11.9l-.708-.707 2.829-2.828-2.829-2.828.708-.708 2.828 2.829 2.828-2.829.707.708z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCross);
export default __webpack_public_path__ + "static/media/shield-cross.accfcba9600124bdb01c1f7f737e88dc.svg";
export { ForwardRef as ReactComponent };